import { createContext } from "react";

export const SidebarContext = createContext({
  toggleSidebar: false,
  setToggleSidebar: () => {},
  sidebarCollapsed: false,
  setSidebarCollapsed: () => {},
});
